/**
 * @file Registre des implementations de modes (ModeId -> fabrique). Ajouter un mode = ModeDef dans config/modes + une ligne ici.
 */
import type { ModeId } from '@shared/enums';
import type { ModeDef } from '@config/types';
import { Registry } from '../util/Registry';
import { MainMode } from './impl/MainMode';
import { MonsterMode } from './impl/MonsterMode';
import { BossMode, RaidMode } from './impl/BossModes';
import { AdventureMode, FishMode, HarvestMode, HubMode, MineMode, SpeedRunMode } from './impl/SkeletonModes';
import type { ModeInstance } from './ModeTypes';

export type ModeFactory = (def: ModeDef) => ModeInstance;

export const MODE_REGISTRY = new Registry<ModeId, ModeFactory>('Mode')
  .register('main', (d) => new MainMode(d as ModeDef<'main'>))
  .register('monster', (d) => new MonsterMode(d as ModeDef<'monster'>))
  .register('speedRun', (d) => new SpeedRunMode(d as ModeDef<'speedRun'>))
  .register('mine', (d) => new MineMode(d as ModeDef<'mine'>))
  .register('boss', (d) => new BossMode(d as ModeDef<'boss'>))
  .register('raid', (d) => new RaidMode(d as ModeDef<'raid'>))
  .register('harvest', (d) => new HarvestMode(d as ModeDef<'harvest'>))
  .register('adventure', (d) => new AdventureMode(d as ModeDef<'adventure'>))
  .register('fish', (d) => new FishMode(d as ModeDef<'fish'>))
  .register('hub', (d) => new HubMode(d as ModeDef<'hub'>));
